import { Component, OnInit, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DebugClockService } from './services/util/debug-clock.service';
import { addIcons } from 'ionicons';
import {
  alertCircleOutline,
  checkmarkCircleOutline,
  close,
} from 'ionicons/icons';
import { App } from '@capacitor/app';
import { QrCodeService } from './services/qr-code/qr-code.service';
import { DeepLinkService } from './services/deep-link/deep-link.service';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
  standalone: false,
})
export class AppComponent implements OnInit {
  private readonly qrCodeService = inject(QrCodeService);
  private readonly deepLinkService = inject(DeepLinkService);
  private readonly router = inject(Router);

  constructor() {
    const route = inject(ActivatedRoute);
    const debugClock = inject(DebugClockService);

    // The icons are used inside toasts.
    addIcons({ close, alertCircleOutline, checkmarkCircleOutline });
    route.queryParamMap.subscribe((params) => {
      if (params.get('clock')) {
        debugClock.show();
      }
      // Do not hide clock again in order to keep it visible after navigation to another page
    });
  }

  ngOnInit(): void {
    // Handle deep links when the app is already running
    App.addListener('appUrlOpen', (event) => {
      this.tryHandleUrl(event.url);
    });

    // Handle deep link on cold start
    App.getLaunchUrl()
      .then((ret) => {
        if (ret?.url) {
          this.tryHandleUrl(ret.url);
        }
      })
      .catch(() => {
        // ignore
      });
  }

  private tryHandleUrl(url: string) {
    try {
      const joinCode = this.qrCodeService.getCodeFromJoinUrl(url);
      if (joinCode) {
        this.deepLinkService.emitJoinCode(joinCode);
        // Navigate to org selection where the code will be processed
        this.router.navigate(['/org-selection']).catch(() => {
          /* ignore navigation errors */
        });
      }
    } catch {
      // ignore invalid URLs
    }
  }
}
